import { Controller } from "@hotwired/stimulus";

/**
 * Shows Telegram button to submit form on Desktop
 * Docs: https://core.telegram.org/bots/webapps#bottombutton
 *
 * Usage:
 *   1. Add `data-controller="mini-app--telegram-form" data-action: "input->mini-app--telegram-form#showMainButton" }` on form tag
 *
 * Example:
 *   <form data-controller="mini-app--telegram-form" data-action="input->mini-app--telegram-form#showMainButton">
 *     ...
 *   </form>
 */

// Connects to data-controller="mini-app--telegram-form"
export default class extends Controller {
  connect() {
    window.Telegram.WebApp.MainButton.text = "Сохранить";
    window.Telegram.WebApp.MainButton.onClick(() =>
      this.element.requestSubmit(),
    );
  }

  disconnect() {
    window.Telegram.WebApp.MainButton.hide();
  }

  showMainButton() {
    if (!this.#isDeviceMobile) window.Telegram.WebApp.MainButton.show();
  }

  get #isDeviceMobile() {
    const mobilePlatform = new RegExp("Android|webOS|iPhone|iPad|iPod", "i");
    return mobilePlatform.test(navigator.userAgent);
  }
}
